import mock from './mock'

import './jwt'
import './apps/todo'
import './apps/invoice'
import './apps/userList'

mock.onAny().passThrough()
